export const constants = {
  Screen: {
    HEIGHT_PORTRAIT: 1920,
    HEIGHT_LANDSCAPE: 1080,
  },
  Bundles: {
    SKELETONS: "skeletons",
    SPRITES: "sprites",
    AUDIO: "audio",
    FONTS: "fonts",
  },
  // NOTE: Please comment-out or remove unused events.
  GameEvents: {
    VIEWPORT_RESIZED: "viewportResized",
    LANDSCAPE_LAYOUT_REQUESTED: "landscapeSizingRequested",
    PORTRAIT_LAYOUT_REQUESTED: "portraitSizingRequested",
    DEVICE_CHANGED: "deviceChanged",
    GAME_INITIALIZE: "gameInitialize",
    GAME_PERFORM_ACTION: "gamePerformAction",
    GAME_REQUEST_ACTION: "gameRequestAction",
    BET_UPDATED: "betUpdated",
    REEL_PANEL_SPIN_STOPPED: "reelPanelSpinStopped",
    CELL_PANEL_SPIN_STOPPED: "cellPanelSpinStopped",
    // SYMBOL_WIN_ANIMATION_STARTED: "symbolWinAnimationStarted",
    SYMBOL_LANDED: "symbolLanded",
    SYMBOL_WIN_ANIMATION_ENDED: "symbolWinAnimationEnded",
    SCATTER_WIN_ANIMATION_ENDED: "symbolWinAnimationEnded",
    SYMBOL_REEL_STOPPED: "symbolReelStopped",
    CELL_STOPPED: "cellStopped",
    SYMBOL_REEL_STOP_REQUESTED: "symbolReelStopRequested",
    SYMBOL_REEL_SPIN_REQUESTED: "symbolReelSpinRequested",
    CELL_STOP_REQUESTED: "cellStopRequested",
    CELL_SPIN_REQUESTED: "cellSpinRequested",
    SYMBOL_REEL_ANTICIPATION_SPIN_REQUESTED:
      "symbolReelAnticipationSpinRequested",
    SYMBOL_REEL_ANTICIPATION_STOP_REQUESTED:
      "symbolReelAnticipationStopRequested",
    FREESPIN_INTRO_CLOSED: "freespinIntroClosed",
    FREESPIN_INTRO_OPEN_ANIMATION_STARTED: "freespinIntroOpenAnimationStarted",
    FREESPIN_INTRO_OPEN_ANIMATION_ENDED: "freespinIntroOpenAnimationEnded",
    FREESPIN_OUTRO_CLOSED: "freespinOutroClosed",
    SYMBOL_PANEL_SHOWN: "symbolPanelShown",
    SYMBOL_PANEL_HIDDEN: "symbolPanelHidden",
    SYMBOL_PANEL_SHOW_ANIMATION_STARTED: "symbolPanelShowAnimationStarted",
    SYMBOL_PANEL_HIDE_ANIMATION_STARTED: "symbolPanelHideAnimationStarted",
    CELL_PANEL_HIDDEN: "cellPanelHidden",
    CELL_PANEL_SHOWN: "cellPanelShown",
    CELL_PANEL_SHOW_ANIMATION_STARTED: "cellPanelShowAnimationStarted",
    CELL_PANEL_HIDE_ANIMATION_STARTED: "cellPanelHideAnimationStarted",
    WINNING_POPUP_OPENED: "winningPopupOpened",
    WINNING_POPUP_CLOSED: "winningPopupClosed",
    COIN_SPLASH_STOPPED: "coinSplashStopped",
    HIGHLIGHT_SPECIFIC_WIN: "highlightSpecificWin",
    MODIFIED_AUTOPLAY_COUNT: "modifiedAutoplayCount",
    CELL_ANIMATION_REQUESTED: "cellAnimationRequested",
    SPECIAL_EFFECT_APPLIED: "specialEffectApplied",
  },
  UIEvents: {
    // TODO: Separate spacebar from spin button
    POINTER_UP: "pointerUp",
    POINTER_MOVE: "pointerMove",
    CLICKED_UI_BUTTON: "clickedUIButton",
    CLICKED_RIG_BUTTON: "clickedRigButton",
    CLICKED_SWIFT_BUTTON: "clickedSwiftButton",
    CLICKED_INTERACTABLE_AREA: "clickedInteractableArea",
    SELECTED_AUTOPLAY_COUNT: "selectedAutoplayCount",
  },
  UIButtonTypes: {
    POPUP_BUTTON: "popupButton",
    SOUND: "sound",
    BET: "bet",
    BET_SELECTION: "betSelection",
    CHEAT: "cheat",
    INFO: "info",
    AUTOPLAY: "autoplay",
    SWIFT: "swift",
    SPIN: "spin",
    // For keys like spacebar, enter
    ACTION: "action",
    // BUY: "bet",
    // MENU: "bet",
    // HOME: "bet",
  },
  // TODO: Fill and replace in-game literal strings
  SymbolTypes: {},
  // TODO: Fill and replace in-game literal ints
  Layers: {
    SYMBOL: 1,
    SYMBOL_HIGHLIGHTED: 2,
  },
  BetToWinRatios: {
    SMALL: 5.0,
    NORMAL: 20.0,
    BIG: 40.0,
    SUPER: 80.0,
  },
} as const;
